export default __webpack_public_path__ + "static/media/spaceShipB2.3ece6a2e.webp";